import { SliceCaseReducers } from '@reduxjs/toolkit/src/createSlice';

import { TaskStoppageProps } from '../../../types/reduxTypes/taskStoppage';

const createReducer = <T extends SliceCaseReducers<TaskStoppageProps>>(reducer: T) => ({ ...reducer });

const reducers = createReducer({
  setTaskStoppageData(state, action) {
    state.taskStoppageData = action.payload;
  },
  setTaskStoppageStatus(state, action) {
    state.taskStoppageStatus = action.payload;
  }
});

export default reducers;
